import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_1b0c1aa7";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_1b0c1aa7" };
/** script content **/
require("./swipe.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex1b0c1aa7%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fswipe%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_1b0c1aa7"],
    ctorType: "component",
    outputPath: "components/index1b0c1aa7/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-swipe-item': getComponent(require("../swipe-item/index.mpx?isComponent&outputPath=components%2Findex4fd03dcd%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
